<template>
	<!-- una bandierina per lingua, come in Email template: a colori dove il nome c'e', in grigio dove manca -->
	<div class="lingue-flags">
		<img v-for="l in lingue || []" :key="l.lang" :src="bandiera(l.lang)" :alt="l.lang" :class="{ 'lingue-flag--off': !l.nome }" :title="titolo(l)" />
	</div>
</template>

<script>
/**
 * Stato delle traduzioni nelle liste del BO (marche, categorie, attributi, varianti, tag).
 * `lingue` arriva dal backend: [{ lang: 'it', nome: true }, { lang: 'en', nome: false }, ...].
 */
export default {
	name: 'LingueFlags',
	props: {
		lingue: { type: Array, default: () => [] },
	},
	methods: {
		bandiera(lang) {
			try {
				return require(`@/assets/images/flag/${String(lang).toUpperCase()}.svg`);
			} catch (e) {
				return require('@/assets/images/flag/map.svg');
			}
		},
		titolo(l) {
			return String(l.lang || '').toUpperCase() + (l.nome ? ' compilata' : ' da completare');
		},
	},
};
</script>

<style scoped>
.lingue-flags {
	display: flex;
	flex-wrap: nowrap; /* in colonna stretta (es. attributi con tanti valori) le bandierine restano su una riga */
	gap: 4px;
}
.lingue-flags img {
	width: 20px;
	height: 14px;
	object-fit: cover;
	border-radius: 2px;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.lingue-flags img.lingue-flag--off {
	filter: grayscale(1);
	opacity: 0.35;
}
</style>
